import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface PremiumValue {
	value: boolean
	/** false enquanto o perfil não respondeu: `value` ainda é só o default */
	loaded: boolean
}

const initialState: PremiumValue = {
	value: false,
	loaded: false,
	// comportamento default abaixo
	/* 	value: storage.get('sideBar') === 'true' ? 'false' : 'true', */
}

export const premiumSlice = createSlice({
	name: 'premium',
	initialState,
	reducers: {
		setIsPremium: (
			state,
			{ payload: { value } }: PayloadAction<{ value: boolean }>
		) => {
			state.value = value
			state.loaded = true
		},
	},
})

export const premiumCreators = premiumSlice.actions

export const premiumReducer = premiumSlice.reducer
